import React, { useState } from "react";
import Topbar from "../../components/Topbar";
import Bottombar from "../../components/Bottombar";
import Header from "../../components/Header";

function FAQPage() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: "How can I reset my password?",
      answer:
        "Click on 'Forgot Password' on the login page, and follow the instructions sent to your email.",
    },
    {
      question: "How can I contact customer support?",
      answer:
        "You can contact us through the phone numbers or emails provided on the Contact page.",
    },
    {
      question: "Where can I find more resources?",
      answer: "Visit our resources page for detailed guides and documentation.",
    },
    {
      question: "Can I change my email address after registration?",
      answer:
        "Yes, you can change your email address by navigating to the 'Account Settings' section and updating your email details.",
    },
    {
      question: "What should I do if I encounter a technical issue?",
      answer:
        "If you encounter a technical issue, please reach out to our support team with a detailed description of the problem.",
    },
    {
      question: "How do I update my profile information?",
      answer:
        "Log in to your account, go to 'Profile Settings,' and update your information. Make sure to save changes before exiting.",
    },
    {
      question: "Is my data secure on this platform?",
      answer:
        "Yes, we use advanced encryption and follow strict security protocols to ensure your data remains private and secure.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept credit cards, debit cards, PayPal, and several other regional payment options. Visit our Payment Methods page for more details.",
    },
    {
      question: "Can I cancel my subscription at any time?",
      answer:
        "Yes, you can cancel your subscription from the 'Subscription Management' section. Note that cancellation policies may vary depending on your plan.",
    },
    {
      question: "How do I download the mobile app?",
      answer:
        "Our mobile app is available on both the App Store and Google Play. Search for our app by name and download it to your device.",
    },
    {
      question: "Why am I not receiving email notifications?",
      answer:
        "Please check your spam or junk folder. Also, ensure that notifications are enabled in your account settings.",
    },
    {
      question: "Can I use this service offline?",
      answer:
        "Some features are available offline, but you'll need an active internet connection for full functionality.",
    },
    {
      question: "Do you offer any discounts or promotions?",
      answer:
        "Yes, we offer seasonal discounts and promotions. Keep an eye on our announcements or subscribe to our newsletter for updates.",
    },
    {
      question: "How do I report a bug or give feedback?",
      answer:
        "Go to the 'Help Center' and click on 'Report an Issue' or 'Send Feedback' to submit your concerns or suggestions.",
    },
    {
      question: "What happens if I forget my username?",
      answer:
        "If you forget your username, use the 'Forgot Username' option on the login page to retrieve it via email.",
    },
    {
      question: "Are there any tutorials available for beginners?",
      answer:
        "Yes, we have step-by-step tutorials and video guides available in the 'Resources' section of our website.",
    },
    {
      question: "Can I share my account with others?",
      answer:
        "No, account sharing is against our terms of service. Each user must have their own account for security reasons.",
    },
    {
      question: "What is the refund policy?",
      answer:
        "We offer refunds under certain conditions. Please refer to our Refund Policy page for detailed information.",
    },
    {
      question: "How can I access beta features?",
      answer:
        "To access beta features, join our beta testing program by signing up through the 'Beta Features' section of your account settings.",
    },
    {
      question: "Is customer support available 24/7?",
      answer:
        "Our customer support team is available 24/7 for premium users. For standard users, support hours are Monday-Friday, 9 AM - 6 PM.",
    },
  ];
  

  return (
    <div className="dark:bg-black bg-white h-screen w-screen">
        <Topbar />
        <Header />
      <div className="flex flex-col mt-2 dark:bg-black bg-white">
        <div className="bg-[#fff] dark:bg-black overflow-x-hidden overflow-y-auto h-[85vh] w-full z-10">
          <div className="text-black dark:text-white font-sans font-bold text-[20px] sm:ml-[5rem] ml-3 mt-2">
            FAQs
          </div>
          <div className="bg-white dark:bg-black h-full p-5">
            {faqs.map((faq, index) => (
              <div key={index} className="mb-4">
                <div
                  className="flex justify-between items-center cursor-pointer p-3 bg-gray-100 dark:bg-gray-800 rounded-md"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="text-black dark:text-white font-semibold">
                    {faq.question}
                  </span>
                  <span className="text-black dark:text-white">
                    {openFAQ === index ? "-" : "+"}
                  </span>
                </div>
                {openFAQ === index && (
                  <div className="p-3 text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-900 rounded-md mt-2">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="sm:hidden absolute bottom-0 z-40 w-full">
        <Bottombar activeBar="faq" />
      </div>
    </div>
  );
}

export default FAQPage;
